import React from "react";
import TableBody from "@material-ui/core/TableBody";

import { ConsultantImport_RowFragment as Row } from "@graphql";
import { ConsultantImportStore } from "../ConsultantImportStore";
import { useObserver } from "mobx-react";
import { ConsultantTableRow } from "./ConsultantTableRow";

export type ConsultantTableBodyProps = {
  store: ConsultantImportStore;
};

export function ConsultantTableBody(props: ConsultantTableBodyProps) {
  const { store } = props;

  return useObserver(() => (
    <TableBody>
      {store.data.map((row: Row, i) => (
        <ConsultantTableRow key={row.RowID} row={row} rowNum={i + 1} />
      ))}
    </TableBody>
  ));
}
